export default "__VITE_ASSET__BkHmjDcC__"